module.exports = __webpack_public_path__ + "img/menuboard-designer.0152fdbc.webp";